import { render, staticRenderFns } from "./FavoritesDrawer.vue?vue&type=template&id=0629d4ea&scoped=true"
import script from "./FavoritesDrawer.vue?vue&type=script&lang=js"
export * from "./FavoritesDrawer.vue?vue&type=script&lang=js"
import style0 from "./FavoritesDrawer.vue?vue&type=style&index=0&id=0629d4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0629d4ea",
  null
  
)

export default component.exports